import * as Sentry from '@sentry/vue'
import type { App } from 'vue'

export const initSentry = (app: App) => {
  Sentry.init({
    app,
    dsn: import.meta.env.VITE_SENTRY_DNS,
    environment: import.meta.env.VITE_SENTRY_ENV,
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
  })
}
